import * as z from "zod";
import {
  AppleMessagesBusinessLinkSchema,
  appleMessagesBusinessIdSchema,
} from "./apple-messages-business-link";

export const getAppleMessagesBusinessLink = {
  name: "getAppleMessagesBusinessLink" as const,
  input: z.object({ businessId: appleMessagesBusinessIdSchema }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal("unlinked") }),
    z.object({
      status: z.literal("linked"),
      link: AppleMessagesBusinessLinkSchema,
    }),
    /** Linked to a different Redo store; nothing about that store is shared. */
    z.object({ status: z.literal("linkedElsewhere") }),
  ]),
};
